@let sectionData = section();

<interacta-accordion
    [attr.data-testid]="sectionData.testId"
    [isOpen]="isOpen()"
    [label]="section().label"
    [size]="'extra-large'"
    (toggleOpen)="toggleAccordion.emit(sectionData.id)"
>
    <div class="flex flex-col gap-y-24 rounded-2xl bg-surface-B p-16">
        @for (group of sectionData.groups; track group.id) {
            @if (group.label) {
                <h3 class="typo-t5">
                    {{ group.label }}
                </h3>
            }
            <ul class="flex flex-wrap gap-x-32 gap-y-40">
                @for (link of group.links; track link.id) {
                    <li>
                        <interacta-link-card
                            [index]="$index"
                            [normalizedLink]="link"
                            (linkActivated)="linkActivated.emit()"
                            (loadError)="loadError.emit($event)"
                        />
                    </li>
                }
            </ul>
        }
    </div>
</interacta-accordion>
